import React, { FunctionComponent } from 'react';
import { ConfirmationStepHeader } from './components/ConfirmationStepHeader';
import { StepContainer } from '../../../StepContainer';
import styles from './styles.module.scss';
import { CourseShareLinks } from '../../../Confirmation/CourseShareLinks';
import { useBookingRequestCheckoutContext } from '../../../CheckoutContext/BookingRequestContext';
import { EmailConfirmationCard } from './components/EmailConfirmationCard';

export const ConfirmationStep: FunctionComponent = () => {
    const { course, educator, checkoutState } = useBookingRequestCheckoutContext();

    return (
        <StepContainer course={course} optimisticCheckoutState={checkoutState}>
            <div className={styles.container}>
                <ConfirmationStepHeader />
                <EmailConfirmationCard
                    requestId={checkoutState.requestId}
                    educatorName={educator.name}
                />
                <CourseShareLinks course={course} educatorFeatureFlags={educator.feature_flags} />
            </div>
        </StepContainer>
    );
};
